/** Default height for each tree node in pixels. */
export const DEFAULT_NODE_HEIGHT: number = 24

/** Default indentation width for each level of the tree in pixels. */
export const DEFAULT_INDENT_WIDTH: number = 20

/** Size of the expand/collapse icon in pixels. */
export const ICON_SIZE: number = 16

/** Padding around the icon. */
export const ICON_PADDING: number = 4

/** Color for the expand/collapse icon. */
export const ICON_COLOR: string = '#bbbfc4'

/** Color for the node label text. */
export const LABEL_COLOR: string = '#333'

/** Font size for the node label. */
export const LABEL_FONT_SIZE: number = 14

/** Font family for the node label. */
export const LABEL_FONT_FAMILY: string = 'Arial, sans-serif'

/** Color for the hover state of a node. */
export const NODE_HOVER_COLOR: string = '#f0f0f0'

/** Delay in milliseconds for showing hover actions. */
export const HOVER_ACTION_DELAY: number = 300

/** Minimum height for the custom scrollbar thumb in pixels. */
export const MIN_SCROLLBAR_THUMB_HEIGHT: number = 20
